import { render, staticRenderFns } from "./sp-check.vue?vue&type=template&id=cfc3edb4"
import script from "./sp-check.vue?vue&type=script&lang=js"
export * from "./sp-check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports